export const MAILTYPES = {
  SUPPORT: "SUPPORT",
  CONTACT: "CONTACT",
};
